/* @flow strict */

import * as React from 'react';
import _ from 'lodash';
import VipCodeForm from '../codeForm/vipCodeForm';
import Ticket from '../ticket/ticket';
import TicketDonation from '../ticket/ticketDonation';

type StepTicketsType = {
    eventDetail: {
        has_vip_codes: boolean
    },
    visibleTickets: [],
    visibleVipTickets: [],
    visibleDonations: [],
    buyCart: [],
    hiddenTickets: [],
    onHandleAddToVipTickets: () => void,
    onHandleChangeDonationPrefliedAmount: () => void,
    onHandleAddTicket: () => void,
    onHandleRemoveTicket: () => void,
    onHandleChangeDonation: () => void,
    onHandleSetDonatedTotal: () => void
};

export const StepTickets = (props: StepTicketsType): React.Element<'div'> => {
    const {
        eventDetail,
        visibleTickets,
        visibleVipTickets,
        visibleDonations,
        buyCart,
        hiddenTickets,
        onHandleSetDonatedTotal,
        onHandleChangeDonationPrefliedAmount,
        onHandleAddTicket,
        onHandleRemoveTicket,
        onHandleAddToVipTickets,
        onHandleChangeDonation
    } = props;

  return (
    <>
      {!!_.size(hiddenTickets) && eventDetail.has_vip_codes &&
      <VipCodeForm
        eventDetail={eventDetail}
        visibleTickets={visibleTickets}
        visibleVipTickets={visibleVipTickets}
        onHandleAddToVipTickets={onHandleAddToVipTickets}
      />
      }

      <div
        className="sparxo-embed-list-wrapper"
        style={{ 'minHeight': '240px' }}
      >
        {!!_.size(visibleVipTickets) &&
        _.map(visibleVipTickets, (t: {}, ti: number): React.Element<'div'> => (
          <Ticket
            key={`sparxo-embeded-list-${ti}`}
            ticket={t}
            visibleTickets={visibleTickets}
            eventDetail={eventDetail}
            buyCart={buyCart}
            isVip
            onHandleChangeDonationPrefliedAmount={onHandleChangeDonationPrefliedAmount}
            onHandleAddTicket={onHandleAddTicket}
            onHandleRemoveTicket={onHandleRemoveTicket}
          />
        ))
        }
        {!!_.size(visibleTickets) &&
        _.map(visibleTickets, (t: {}, ti: number): React.Element<'div'> => (
          <Ticket
            key={`sparxo-embeded-list-${ti}`}
            ticket={t}
            visibleTickets={visibleTickets}
            eventDetail={eventDetail}
            buyCart={buyCart}
            onHandleChangeDonationPrefliedAmount={onHandleChangeDonationPrefliedAmount}
            onHandleAddTicket={onHandleAddTicket}
            onHandleRemoveTicket={onHandleRemoveTicket}
          />
        ))
        }
        {!!_.size(visibleDonations) &&
        _.map(visibleDonations, (data: {}, index: number): React.Element<'div'> => (
          <TicketDonation
            key={`sparxo-donation-list-${index}`}
            data={data}
            eventDetail={eventDetail}
            onHandleChangeDonation={onHandleChangeDonation}
            onHandleSetDonatedTotal={onHandleSetDonatedTotal}
          />
        ))
        }
      </div>
    </>
  );
};
